<template>
  <div class="row g-3">

    <!-- ── Grupo: Observaciones ─────────────────────────── -->
    <div class="col-12">
      <h6 class="text-muted text-uppercase small fw-bold mb-2">
        <span class="material-symbols-outlined align-middle me-1" style="font-size:16px">
          visibility
        </span>
        Observaciones
      </h6>
      <div class="row g-2">
        <div class="col-md-3" v-if="supervisor">
          <router-link
            :to="{ name: 'ObservacionesReportes', params: { p_idtramite: idTramite } }"
            class="btn btn-outline-primary w-100 d-flex align-items-center gap-2"
          >
            <span class="material-symbols-outlined">manage_search</span>
            Consulta de Observaciones
          </router-link>
        </div>
        <div class="col-md-3" v-if=" supervisor || reporteObsResp > 0 ">
          <router-link
            :to="{ name: 'ObsRespReportes', 
                   params: { p_idtramite: idTramite, p_idservicio: idServicio, p_estadoTramite: estadoTramite } }"
            class="btn btn-outline-primary w-100 d-flex align-items-center gap-2"
          >
            <span class="material-symbols-outlined">question_answer</span>
            Observaciones y Respuestas
          </router-link>
        </div>
        <div  v-if="supervisor" class="col-md-3">
          <router-link
            :to="{ name: 'ObservacionesTramite', params: { p_idtramite: idTramite } }"
            class="btn btn-outline-primary w-100 d-flex align-items-center gap-2"
          >
            <span class="material-symbols-outlined">assignment</span>
            Obs.
            <span v-if="idPerfil == 17">A. M.</span>
            <span v-else-if="idPerfil == 19">G. D.</span>
            (Todas)
          </router-link>
        </div>
        <div v-if=" supervisor || reporteObsReex > 0 " class="col-md-3">
          <router-link
            :to="{ name: 'ObservacionesFinanciador',
                   params: { p_idtramite: idTramite, p_idservicio: idServicio, p_estadoTramite: estadoTramite } }"
            class="btn btn-outline-primary w-100 d-flex align-items-center gap-2"
          >
            <span class="material-symbols-outlined">manage_search</span>
            Observaciones Financiador
          </router-link>
        </div>
      </div>
    </div>

    <!-- ── Grupo: Resúmenes ──────────────────────────────── -->
    <div v-if="supervisor" class="col-12">
      <h6 class="text-muted text-uppercase small fw-bold mb-2">
        <span class="material-symbols-outlined align-middle me-1" style="font-size:16px">
          summarize
        </span>
        Resúmenes
      </h6>
      <div class="row g-2">
        <div class="col-md-3">
          <router-link
            :to="{ name: 'ResumenObsResp', params: { p_idtramite: idTramite } }"
            class="btn btn-outline-success w-100 d-flex align-items-center gap-2"
          >
            <span class="material-symbols-outlined">bar_chart</span>
            Resumen Obs. y Respuestas
          </router-link>
        </div>
        <div class="col-md-3">
          <router-link
            :to="{ name: 'ResumenJustificadas', params: { p_idtramite: idTramite } }"
            class="btn btn-outline-success w-100 d-flex align-items-center gap-2"
          >
            <span class="material-symbols-outlined">fact_check</span>
            Resumen de Justificadas
          </router-link>
        </div>
        <div class="col-md-3">
          <router-link
            :to="{ name: 'ResumenTiempoObs', params: { p_idtramite: idTramite } }"
            class="btn btn-outline-success w-100 d-flex align-items-center gap-2"
          >
            <span class="material-symbols-outlined">schedule</span>
            Resumen Tiempo Obs.
          </router-link>
        </div>
        <div class="col-md-3">
          <router-link
            :to="{ name: 'TramiteNovedades', params: { p_idtramite: idTramite } }"
            class="btn btn-outline-success w-100 d-flex align-items-center gap-2"
          >
            <span class="material-symbols-outlined">notifications</span>
            Novedades
          </router-link>
        </div>
      </div>
      <br>
      <div class="row g-2">
        <div class="col-md-3">
          <router-link
            :to="{ name: 'ResumenTopObsEstandar', params: { p_idtramite: idTramite } }"
            class="btn btn-outline-success w-100 d-flex align-items-center gap-2"
          >
            <span class="material-symbols-outlined">workspace_premium</span>
            Top Observaciones
          </router-link>
        </div>
        <div class="col-md-3">
        </div>
        <div class="col-md-3">
        </div>
        <div class="col-md-3">
        </div>
      </div>
    </div>

    <!-- ── Grupo: Datos ───────────────────────────────── -->
    <div  v-if="supervisor" class="col-12">
      <h6 class="text-muted text-uppercase small fw-bold mb-2">
        <span class="material-symbols-outlined align-middle me-1" style="font-size:16px">
          fact_check
        </span>
        Datos
      </h6>
      <div class="row g-2">
        <div class="col-md-3">
          <router-link
            :to="{ name: 'PlanillasBorradas', params: { p_idtramite: idTramite } }"
            class="btn btn-outline-warning text-dark w-100 d-flex align-items-center gap-2"
          >
            <span class="material-symbols-outlined">merge</span>
            Planillas anuladas/borradas
          </router-link>
        </div>
        <div class="col-md-3">
          <router-link
            :to="{ name: 'Productividad', params: { p_idtramite: idTramite } }"
            class="btn btn-outline-warning text-dark w-100 d-flex align-items-center gap-2"
          >
            <span class="material-symbols-outlined">trending_up</span>
            Productividad
          </router-link>
        </div>
      </div>
    </div>

    <!-- ── Grupo: Ajustes ───────────────────────────────── -->
    <div v-if="supervisor" class="col-12">
      <h6 class="text-muted text-uppercase small fw-bold mb-2">
        <span class="material-symbols-outlined align-middle me-1" style="font-size:16px">
          tune
        </span>
        Ajustes
      </h6>
      <div class="row g-2">
        <div class="col-md-3">
          <router-link
            :to="{ name: 'UnificacionCodigos', params: { p_idtramite: idTramite } }"
            class="btn btn-outline-warning text-dark w-100 d-flex align-items-center gap-2"
          >
            <span class="material-symbols-outlined">merge</span>
            Unificación de códigos
          </router-link>
        </div>
        <div class="col-md-3">
          <router-link
            :to="{ name: 'CodigosNoMapeados', params: { p_idtramite: idTramite } }"
            class="btn btn-outline-warning text-dark w-100 d-flex align-items-center gap-2"
          >
            <span class="material-symbols-outlined">link_off</span>
            Códigos no mapeados
          </router-link>
        </div>
        <div class="col-md-3">
          <router-link
            :to="{ name: 'FueraDePeriodo', params: { p_idtramite: idTramite } }"
            class="btn btn-outline-warning text-dark w-100 d-flex align-items-center gap-2"
          >
            <span class="material-symbols-outlined">event_busy</span>
            Fuera de periodo
          </router-link>
        </div>
      </div>
    </div>

    <!-- ── Grupo: Archivos ───────────────────────────────── -->
    <div v-if="supervisor" class="col-12">
      <h6 class="text-muted text-uppercase small fw-bold mb-2">
        <span class="material-symbols-outlined align-middle me-1" style="font-size:16px">
          folder_open
        </span>
        Archivos
      </h6>
      <div class="row g-2">
        <div class="col-md-3">
          <router-link
            :to="{ name: 'PlanillaResumen', params: { p_idtramite: idTramite } }"
            class="btn btn-outline-warning text-dark w-100 d-flex align-items-center gap-2"
          >
            <span class="material-symbols-outlined">table_view</span>
            Resumen de planillas
          </router-link>
        </div>
        <div class="col-md-3">
          <router-link
            :to="{ name: 'ArchivoCarga', params: { p_idtramite: idTramite } }"
            class="btn btn-outline-warning text-dark w-100 d-flex align-items-center gap-2"
          >
            <span class="material-symbols-outlined">download</span>
            Archivo de carga
          </router-link>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "TramiteReportes",
  data() {
    return {
      p_idUsuario: 0,
      reporteObsResp: 0,
      reporteObsReex: 0,
    };
  },
  props: {
    idTramite:     { type: Number,  required: true },
    idServicio:    { type: Number,  required: true },
    estadoTramite: { type: String,  required: true },
    idPerfil:      { type: Number,  required: true },
    verReportes:   { type: Number,  required: true },
    supervisor:    { type: Boolean, required: true },
  },
  mounted(){
    this.p_idUsuario    = Number(window.sessionStorage.getItem("idUsuario"));
    this.reporteObsResp = Number(window.sessionStorage.getItem("reporteObsResp"));
    this.reporteObsReex = Number(window.sessionStorage.getItem("reporteObsReex"));
//alert("1 idTramite: "+this.idTramite);
//alert("1 idServicio: "+this.idServicio);
//alert("1 estadoTramite: "+this.estadoTramite);
  },
};
</script>